<template>
  <div class="main">
    <div class="title">{{ $t('account_type.totype') }}</div>
    <div class="main_centent">
      <div class="type_select  CU" :class="type == 0 ? 'type_select_active' : ''" @click="select(0)">
        <img class="type_active" v-if="type == 0" src="@/img/type.png" alt="" />
        <div class="type_select_url"><img class="type_select_img" src="@/img/cp.png" alt="" /></div>
        <div class="type_title">{{ $t('account_type.game') }}</div>
        <div class="type_text">{{ $t('account_type.cptext') }}</div>
      </div>
      <div class="type_select CU" :class="type == 1 ? 'type_select_active' : ''" @click="select(1)">
        <img class="type_active" v-if="type == 1" src="@/img/type.png" alt="" />
        <div class="type_select_url"><img class="type_select_img" src="@/img/app.png" alt="" /></div>
        <div class="type_title">{{ $t('account_type.app') }}</div>
        <div class="type_text">{{ $t('account_type.apptext') }}</div>
      </div>
    </div>
    <div class="typebtn CU" @click="send">{{ $t('account_type.confirm') }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: 0
    };
  },
  methods: {
    // 点击选择类型
    select(index) {
      this.type = index;
    },
    send() {
      this.$router.push({
        path: '/register',
        query: {
          type: this.type
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
.main {
  box-sizing: border-box;
  width: 1160px;
  height: 644px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 83px auto 0;
  padding-top: 72px;
}
.title {
  text-align: center;
  color: #282828;
  font-size: 22px;
}
.main_centent {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
.type_select {
  position: relative;
  width: 300px;
  height: 280px;
  background-color: #fdfefe;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: solid 2px #fff;
  padding-top: 35px;
  margin: 0 40px;
}
.type_select_active {
  border: solid 2px #4990fa;
}
.type_active {
  position: absolute;
  right: 0;
  top: 0;
  width: 44px;
  height: 44px;
}
.type_select_url {
  display: flex;
  justify-content: center;
}
.type_select_img {
  width: 110px;
  height: 110px;
}
.type_title {
  margin-top: 30px;
  color: #282828;
}
.type_text {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
.type_title,
.type_text {
  text-align: center;
}
.typebtn {
  width: 325px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin: 70px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/account_type.vue